import { render, staticRenderFns } from "./platetable.vue?vue&type=template&id=1c325640&scoped=true"
import script from "./platetable.vue?vue&type=script&lang=js"
export * from "./platetable.vue?vue&type=script&lang=js"
import style0 from "./platetable.vue?vue&type=style&index=0&id=1c325640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c325640",
  null
  
)

export default component.exports